import { createRouter, createWebHistory } from 'vue-router';

import Default from '@/module/Home/page/Default.vue';
import Notfound from '@/module/Static/Notfound/page/Notfound.vue';
import RegisterMainPage from "@/module/Register/page/RegisterMainPage.vue";
import LineLoginPage from "@/module/LineLogin/page/LineLogin.vue";
import ProfilePage from "@/module/Profile/page/Profile.vue";
import FAQPage from "@/module/Static/FAQ/page/FAQPage.vue";
import FAQDetailPage from "@/module/Static/FAQ/page/FAQDetailPage.vue"
import History from "@/module/History/page/History.vue";
import HotPromotionPage from "@/module/Promotion/HotPromotion/page/HotPromotionPage.vue";
import SearchPromotionPage from "@/module/Promotion/SearchPromotion/page/SearchPromotionPage.vue";
import SpecialForYouPage from "@/module/Promotion/SpecialForYou/page/SpecialForYouPage.vue";
import PromotionDetailPage from "@/module/Promotion/PromotionDetail/page/PromotionDetailPage.vue"
import ApplyCreditCardPage from "@/module/Profile/page/ApplyCreditCard.vue";
import PlatinumServiceMainPage from "@/module/PlatinumService/page/PlatinumServiceMainPage.vue";
import PlatinumServiceCampaignsPage from "@/module/PlatinumService/page/PlatinumServiceCampaignsPage.vue";
import ContactUsPage from "@/module/Static/Contact-Us/page/ContactUsPage.vue";
import SearchPromotionCampaignsPage from "@/module/Promotion/SearchPromotion/page/SearchPromotionCampaignsPage.vue";
import EditProfilePage from "@/module/Profile/page/EditProfile.vue";
import CardPrivilegesPage from "@/module/CardPrivileges/page/CardPrivilegesPage.vue";
import Welcome from "@/module/Welcome/page/Welcome.vue";
import UltimateServicePage from '@/module/UltimateService/page/UltimateService.vue'
import UltimateServiceCampaignPage from "@/module/UltimateService/page/UltimateServiceCampaignPage.vue";
import PrivacyMenu from "@/module/PrivacyMenu/PrivacyMenu.vue";
import MarketingSetting from "@/module/PrivacyMenu/page/MarketingSetting.vue";
import CopyData from "@/module/PrivacyMenu/page/CopyData.vue";
import TranferData from "@/module/PrivacyMenu/page/TranferData.vue";
import TermsPage from '../module/Static/PDPA/page/Terms.vue';
import PrivacyPage from '../module/Static/PDPA/page/Privacy.vue';


const routes = [
    {
        path: '/',
        name: 'default',
        component: Default
    },
    {
        path: '/linelogin',
        name: 'linelogin',
        component: LineLoginPage
    },
    {
        path: '/profile',
        name: 'profile',
        component: ProfilePage
    },
    {
        path: '/profile/edit',
        name: 'edit-profile',
        component: EditProfilePage
    },
    {
        path: '/apply-card',
        name: 'apply-card',
        component: ApplyCreditCardPage
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterMainPage
    },
    {
        path: '/promotion/hot',
        name: 'promotion-hot',
        component: HotPromotionPage
    },
    {
        path: '/promotion/search',
        name: 'promotion-search',
        component: SearchPromotionPage
    },
    {
        path: '/promotion-search-campaigns/:cat',
        name: 'promotion-search-campaigns',
        component: SearchPromotionCampaignsPage
    },
    {
        path: '/promotion/special4you/:categoryId?',
        name: 'promotion-special4you',
        component: SpecialForYouPage
    },
    {
        path: '/promotion/detail/:campaignId',
        name: 'promotion-detail',
        component: PromotionDetailPage
    },
    {
        path: '/platinum-service',
        name: 'platinum-service',
        component: PlatinumServiceMainPage
    },
    {
        path: '/platinum-campaigns/:cat',
        name: 'platinum-campaigns',
        component: PlatinumServiceCampaignsPage
    },
    {
        path: '/ultimate-service',
        name: 'ultimate-service',
        component: UltimateServicePage
    },
    {
        path: '/ultimate-campaigns/:cat',
        name: 'ultimate-campaigns',
        component: UltimateServiceCampaignPage
    },
    {
        path: '/card-privileges',
        name: 'card-privileges',
        component: CardPrivilegesPage
    },
    {
        path: '/faq',
        name: 'faq',
        component: FAQPage
    },
    {
        path: '/faq-detail/:key',
        name: 'faq-detail',
        component: FAQDetailPage
    },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
    {
        path: '/contact-us',
        name: 'contact-us',
        component: ContactUsPage
    },
    {
        path: '/history',
        name: 'history',
        component: History
    },
    {
        path: '/welcome',
        name: 'welcome',
        component: Welcome
    },
    {
        path: '/privacymenu',
        name: 'privacymenu',
        component: PrivacyMenu
    },
    {
        path: '/marketingsetting',
        name: 'marketingsetting',
        component: MarketingSetting
    },
    {
        path: '/copydata',
        name: 'copydata',
        component: CopyData,
    },
    {
        path: '/tranferdata',
        name: 'tranferdata',
        component: TranferData,
    },
    {
        path: '/terms',
        name: 'terms',
        component: TermsPage,
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: PrivacyPage,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
